export default __webpack_public_path__ + "static/media/1971.52495b97.png";